module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headerintro01",
      "epub:type": "introduction",
      "id": "intro",
      "role": "doc-introduction"
    }
  }, [_c('header', {
    attrs: {
      "id": "headerintro01"
    }
  }, [_c('h1', {
    staticClass: "ct"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page xiv. ",
      "epub:type": "pagebreak",
      "id": "pxiv",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page 1. ",
      "epub:type": "pagebreak",
      "id": "p1",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifoucaultcritique0006#rintro"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p1"
    }
  }), _vm._v("Michel Foucault’s thought underwent a series of transformations, but it always had the same recognizable style. The problem is how to capture both the modifications and this very particular philosophical style. Five years separate the two apparently distinct lectures that make up the heart of this volume. But there is at least one fundamental point of contact between them—namely, Foucault’s engagement with Kant’s text “Was ist Aufklärung?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en1",
      "id": "en1r",
      "role": "doc-noteref"
    }
  }, [_vm._v("1")])]), _vm._v(" In both lectures, Foucault takes the opportunity to reflect on the scope of the Kantian critical enterprise while redefining it radically for his own purposes.")]), _vm._v(" "), _c('p', [_vm._v("References to Kant’s text recur in many of Foucault’s writings between 1978 and 1984,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en2",
      "id": "en2r",
      "role": "doc-noteref"
    }
  }, [_vm._v("2")])]), _vm._v(" but they are usually brief, almost sporadic, without systematic analysis. There are two brief periods that are exceptions to this. First, in 1978, Foucault referred to Kant’s text and the question of the Enlightenment, or Aufklärung, in his introduction to the American translation of Georges Canguilhem’s "), _c('i', [_vm._v("The Normal and the Pathological")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en3",
      "id": "en3r",
      "role": "doc-noteref"
    }
  }, [_vm._v("3")])]), _vm._v(" Foucault then went on to deal with the Aufklärung at length in his lecture to the Société française de Philosophie. We are presenting the critical edition of this lecture here for the first time. Second, in 1983, Foucault dedicated the inaugural lecture "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page 2. ",
      "epub:type": "pagebreak",
      "id": "p2",
      "role": "doc-pagebreak"
    }
  }), _vm._v("of his course at the Collège de France "), _c('i', [_vm._v("The Government of Self and Others")]), _vm._v(" to Kant’s text."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en4",
      "id": "en4r",
      "role": "doc-noteref"
    }
  }, [_vm._v("4")])]), _vm._v(" An extract from this lecture was published as an article in 1984."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en5",
      "id": "en5r",
      "role": "doc-noteref"
    }
  }, [_vm._v("5")])]), _vm._v(" Foucault then also published another essay on the topic in the United States that same year."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en6",
      "id": "en6r",
      "role": "doc-noteref"
    }
  }, [_vm._v("6")])]), _vm._v(" And in the lecture he delivered as part of the Regent’s Lectures at the University of California, Berkeley, on April 12, 1983, Foucault also began with a brief discussion of Kant’s text on the Enlightenment. His aim he says there was “to explain why I am interested in the theme of the culture of the self as a philosophical and historical question.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en7",
      "id": "en7r",
      "role": "doc-noteref"
    }
  }, [_vm._v("7")])]), _vm._v(" We are publishing this lecture here for the first time.")]), _vm._v(" "), _c('p', [_vm._v("The two lectures we are presenting here, “What Is Critique?” and “The Culture of the Self,” form two poles making it possible to examine the evolution of Foucault’s thought between 1978 and 1983. They enable us to reflect on his different readings of “Was ist Aufklärung?” (a veritable toolbox in his hands) and also on the continuities that allow him to link his own historico-philosophical perspective and present and past work to the question of the “critique” introduced by Kant in his text on the Enlightenment. But, according to Foucault, this perspective cannot and should not be identified with Kant’s own celebrated critical enterprise. Although the reference to Kant is pivotal for Foucault from the outset of his career in his supplementary thesis on "), _c('i', [_vm._v("The Anthropology")]), _vm._v(","), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en8",
      "id": "en8r",
      "role": "doc-noteref"
    }
  }, [_vm._v("8")])]), _vm._v(" Foucault highlights "), _c('i', [_vm._v("another")]), _vm._v(" Kant, or at the very least an alternative to the “Kantian” path of the "), _c('i', [_vm._v("Critiques")]), _vm._v(", in an attempt to retrace the genealogy of his own philosophical practice.")]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ahintro01"
    }
  }, [_vm._v("An Indecent Title, or Kant versus Kant")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The year 1978 was crucial in Foucault’s intellectual trajectory. He introduced the theme of governmentality in his course "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page 3. ",
      "epub:type": "pagebreak",
      "id": "p3",
      "role": "doc-pagebreak"
    }
  }), _vm._v("at the Collège de France "), _c('i', [_vm._v("Security, Territory, Population")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en9",
      "id": "en9r",
      "role": "doc-noteref"
    }
  }, [_vm._v("9")])]), _vm._v(" This theme, in the form of the problem of the “government of oneself and others,” was to make up the core of Foucault’s research until 1984. In this course, while retracing the history of the idea and practice of government, Foucault alighted on what he termed “pastoral power” and offered a detailed study and analysis of five “pastoral counter-conducts” in the Middle Ages."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en10",
      "id": "en10r",
      "role": "doc-noteref"
    }
  }, [_vm._v("10")])]), _vm._v(" In addition, in January 1978,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en11",
      "id": "en11r",
      "role": "doc-noteref"
    }
  }, [_vm._v("11")])]), _vm._v(" in the introduction to the American translation of Canguilhem’s "), _c('i', [_vm._v("The Normal and the Pathological")]), _vm._v(", Foucault mentioned (albeit briefly) Kant’s text on the Aufklärung for the first time. He emphasized the fundamental role played by Kant’s work in postwar French thought, pondering the reasons for such a profound link between this type of reflection and the present. He argued that the history of science in France formed the context for the reactivation of the question of the Enlightenment as a way of examining “a reason whose autonomy of structures carries within itself the history of dogmatisms and despotisms.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en12",
      "id": "en12r",
      "role": "doc-noteref"
    }
  }, [_vm._v("12")])]), _vm._v(" The Enlightenment raised the question not just of the nature and basis of rational thought but also of its history and its geography, its past and its present existence. Thus, it was in first situating Canguilhem’s work in the context of this kind of reflection that Foucault was able to describe the inauguration of a “philosophical journalism” at the end of the eighteenth century."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en13",
      "id": "en13r",
      "role": "doc-noteref"
    }
  }, [_vm._v("13")])]), _vm._v(" In proposing an analysis of the “present moment,” this “philosophical journalism” opened up “a whole historico-critical dimension” to philosophy. Cavaillès, Koyré, Bachelard, and Canguilhem (as well as the philosophers of the Frankfurt School) all operated within this tradition."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en14",
      "id": "en14r",
      "role": "doc-noteref"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', [_vm._v("At the beginning of April 1978, Foucault left for a long trip to Japan."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en15",
      "id": "en15r",
      "role": "doc-noteref"
    }
  }, [_vm._v("15")])]), _vm._v(" During his stay he gave a series of important lectures,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en16",
      "id": "en16r",
      "role": "doc-noteref"
    }
  }, [_vm._v("16")])]), _vm._v(" and shortly after his return to France, on May 27, "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page 4. ",
      "epub:type": "pagebreak",
      "id": "p4",
      "role": "doc-pagebreak"
    }
  }), _vm._v("1978, he delivered a lecture to the Société française de Philosophie. Several circumstances make this talk a real unicum in Foucault’s intellectual production, beginning with the title. Indeed, Foucault begins by apologizing for not giving his lecture a title, explaining that the question he wanted to address was, What is critique? (This eventually did become the title when the text was published in the "), _c('i', [_vm._v("Bulletin de la Société française de Philosophie")]), _vm._v(" in 1990). However, Foucault admitted that there was a title that “haunted” him but that ultimately he didn’t want, or even dare, to choose because it would have been “indecent.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en17",
      "id": "en17r",
      "role": "doc-noteref"
    }
  }, [_vm._v("17")])]), _vm._v(" This indecent title was of course “What Is Aufklärung?”—a title Foucault would no longer hesitate to use in 1984."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en18",
      "id": "en18r",
      "role": "doc-noteref"
    }
  }, [_vm._v("18")])]), _vm._v(" This leads one to wonder about the reasons for this hesitation, and the “game” that Foucault proposes to the members of the Société française de Philosophie."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en19",
      "id": "en19r",
      "role": "doc-noteref"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', [_vm._v("It probably has to do with the “torsion” that Foucault subjects the Kantian question of (transcendental) critique to, redirecting it toward what he describes as a “critical attitude.” In fact, according to Foucault, if Kant did indeed transport the critical attitude and the question of the Aufklärung into the question of epistemological-transcendental critique, one now needs to go “down this route [. . .] in the opposite direction.” This can be done by raising the question of the relation between knowledge and domination in terms of “a certain decisive will not to be governed.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en20",
      "id": "en20r",
      "role": "doc-noteref"
    }
  }, [_vm._v("20")])]), _vm._v(" In other words, just as in 1969 the seemingly classic question, What is an author? had been the pretext for making a (scandalous) shift from the author-subject to the author-function,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en21",
      "id": "en21r",
      "role": "doc-noteref"
    }
  }, [_vm._v("21")])]), _vm._v(" in 1978 the question, What is critique? opened up the possibility of making another (indecent) shift for Foucault. The epistemologico-transcendental question, What can I know? becomes here a “question of attitude,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en22",
      "id": "en22r",
      "role": "doc-noteref"
    }
  }, [_vm._v("22")])]), _vm._v(" and critique is redefined as “the movement that allows "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page 5. ",
      "epub:type": "pagebreak",
      "id": "p5",
      "role": "doc-pagebreak"
    }
  }), _vm._v("the subject to take up the right to question the truth on its effects of power and to question power about its discourses of truth.” The goal is “desubjectification in the play of [. . .] the politics of truth.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en23",
      "id": "en23r",
      "role": "doc-noteref"
    }
  }, [_vm._v("23")])]), _vm._v(" It is still in Kant, but in another Kant—the Kant of a “minor” and marginal text like “Was ist Aufklärung?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en24",
      "id": "en24r",
      "role": "doc-noteref"
    }
  }, [_vm._v("24")])]), _vm._v("—that Foucault finds the means to effect this shift. Now we can better understand perhaps what was so indecent about this gesture in a gathering of philosophers.")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ahintro02"
    }
  }, [_vm._v("The Art of Not Being Governed Quite So Much")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("It should be noted, however, that it is not through a commentary on Kant’s text on the Enlightenment that Foucault puts forward his definition of the critical attitude in 1978. This is why we must absolutely resist the temptation to read this lecture in the light of the 1983–84 texts. To do so would be to risk missing its threefold specificity.")]), _vm._v(" "), _c('p', [_vm._v("First, the lecture to the Société française de Philosophie begins as an extension of Foucault’s reflections in his course "), _c('i', [_vm._v("Security, Territory, Population")]), _vm._v(" rather than as a detailed analysis of “Was ist Aufklärung?” Foucault sets out to identify the emergence of a certain way of thinking, speaking, and acting that can be likened to a virtue he labels the “critical attitude.” In his eyes, this emergence is linked to a historical phenomenon specific to the modern West—namely, the proliferation of the arts of governing from the fifteenth to sixteenth centuries onwards. This phenomenon testifies to the expansion into civil society of a form of power developed by the Catholic Church in its “pastoral” activity conducting the daily conduct of individuals."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en25",
      "id": "en25r",
      "role": "doc-noteref"
    }
  }, [_vm._v("25")])]), _vm._v(" So here Foucault is reworking more generally the analyses of “pastoral governmentality” he proposed three months earlier at the Collège de France."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en26",
      "id": "en26r",
      "role": "doc-noteref"
    }
  }, [_vm._v("26")])]), _vm._v(" But he puts "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page 6. ",
      "epub:type": "pagebreak",
      "id": "p6",
      "role": "doc-pagebreak"
    }
  }), _vm._v("forward a new thesis in “What Is Critique?”—namely, that the “governmentalization” that characterizes modern Western societies from the fifteenth to sixteenth centuries onwards cannot be dissociated from the question of “how not to be governed "), _c('i', [_vm._v("like this")]), _vm._v(", by these people, in the name of these principles, in view of these particular goals and by means of these particular processes.” The critical attitude thus receives its first definition without invoking Kant. A “general cultural form,” a “moral and political attitude,” a “way of thinking,” it is both the companion and the adversary of the arts of governing—it is “the art of not being governed quite so much.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en27",
      "id": "en27r",
      "role": "doc-noteref"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', [_vm._v("At the Collège de France, Foucault focused on the points of resistance that had arisen within the Christian pastorate and offered a definition of “counter-conducts” in the Middle Ages. These were attitudes that demonstrated the will “to be conducted differently, by other leaders ["), _c('i', [_vm._v("conducteurs")]), _vm._v("] and other shepherds, toward other objectives and forms of salvation and through other procedures and methods.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en28",
      "id": "en28r",
      "role": "doc-noteref"
    }
  }, [_vm._v("28")])]), _vm._v(" The proximity of this concept to the critical attitude as “the will not to be governed like this, by them, at this price” is obvious."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en29",
      "id": "en29r",
      "role": "doc-noteref"
    }
  }, [_vm._v("29")])]), _vm._v(" The “counter” and the “like this” testify to the always "), _c('i', [_vm._v("local")]), _vm._v(" and "), _c('i', [_vm._v("strategic")]), _vm._v(" dimension of these forms of resistance."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en30",
      "id": "en30r",
      "role": "doc-noteref"
    }
  }, [_vm._v("30")])]), _vm._v(" In fact, at the Société française de Philosophie, Foucault explicitly presents the study of pastoral counterconducts as a stage in the genealogy of the critical attitude."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en31",
      "id": "en31r",
      "role": "doc-noteref"
    }
  }, [_vm._v("31")])]), _vm._v(" The first “historical anchor” he mentions is the “return to scripture,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en32",
      "id": "en32r",
      "role": "doc-noteref"
    }
  }, [_vm._v("32")])]), _vm._v(" and in the discussion after the lecture, he claims that the historical origin of the critical attitude should be sought precisely in the religious struggles of the second half of the Middle Ages."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en33",
      "id": "en33r",
      "role": "doc-noteref"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', [_vm._v("The second unique feature of “What Is Critique?” is Foucault’s interpretation of the Aufklärung. Even if he situates the critical attitude within a history that is broader than just "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page 7. ",
      "epub:type": "pagebreak",
      "id": "p7",
      "role": "doc-pagebreak"
    }
  }), _vm._v("the “Kantian moment,” rendering it “something other than the legacy of a particular stream of philosophical thought,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en34",
      "id": "en34r",
      "role": "doc-noteref"
    }
  }, [_vm._v("34")])]), _vm._v(" he claims his definition of the critical attitude corresponds to the one Kant offered in 1784. This definition saw the Aufklärung as a courageous attempt to emerge from a state of minority imposed by an outside authority on humanity, rendering it unable to use its own understanding outside of a relationship of direction. In Foucault’s reading, the Aufklärung becomes a practical attitude of resistance to a governmental power of direction. This exists within the field of relations between the subject, power, and truth—what Foucault calls the “source of critique,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en35",
      "id": "en35r",
      "role": "doc-noteref"
    }
  }, [_vm._v("35")])]), _vm._v("—and attempts to challenge, undo, or overthrow these relations. So, very clearly and much more explicitly than in his subsequent work,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en36",
      "id": "en36r",
      "role": "doc-noteref"
    }
  }, [_vm._v("36")])]), _vm._v(" Foucault pits the Aufklärung against epistemological critique, which is conceived by Kant as “prolegomena to all Aufklärung of the present and future.” According to Kant, “it’s less about what we undertake with more or less courage, than the idea we have of our knowledge ["), _c('i', [_vm._v("connaissance")]), _vm._v("] and its limits and the implications for our freedom.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en37",
      "id": "en37r",
      "role": "doc-noteref"
    }
  }, [_vm._v("37")])]), _vm._v(" In other words, for Kant, the “courage in knowing” invoked by the Aufklärung consists in recognizing the limits of knowledge and gaining an autonomy that is not opposed to obedience, but on the contrary, constitutes its true foundation. Foucault goes on to assert that this critical enterprise that exists at a distance or “stands back” from the “courage of the Aufklärung” continued on into the nineteenth and twentieth centuries, in the form of the denunciation of the excesses of power that reason itself was historically responsible for."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en38",
      "id": "en38r",
      "role": "doc-noteref"
    }
  }, [_vm._v("38")])]), _vm._v(" Here, Foucault seems to want to distinguish himself clearly from this path, while still recognizing common points of interest with the Frankfurt School."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en39",
      "id": "en39r",
      "role": "doc-noteref"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', [_vm._v("The third feature that makes this lecture to the Société "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page 8. ",
      "epub:type": "pagebreak",
      "id": "p8",
      "role": "doc-pagebreak"
    }
  }), _vm._v("française de Philosophie unique is the long methodological reflection in the final section."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en40",
      "id": "en40r",
      "role": "doc-noteref"
    }
  }, [_vm._v("40")])]), _vm._v(" Foucault returns here to the themes he dealt with a week earlier in a roundtable with historians,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en41",
      "id": "en41r",
      "role": "doc-noteref"
    }
  }, [_vm._v("41")])]), _vm._v(" and also to certain concepts he developed in the second half of the 1960s. He describes a “historico-philosophical” practice that seeks to explore the relationships between “the structures of rationality articulating true discourse and the mechanisms of subjugation linked to it.” This practice entertains a special relationship with the Aufklärung, attempting to ascertain the conditions under which we can apply this “question of the Aufklärung—that is, the question of power relations, truth, and the subject—to any moment in history.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en42",
      "id": "en42r",
      "role": "doc-noteref"
    }
  }, [_vm._v("42")])]), _vm._v(" Redefined in this way, the question of the Aufklärung becomes the perspective Foucault uses to conduct his analyses and to rethink all his work."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en43",
      "id": "en43r",
      "role": "doc-noteref"
    }
  }, [_vm._v("43")])]), _vm._v(" The Aufklärung thus becomes a “trans-historical” question,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en44",
      "id": "en44r",
      "role": "doc-noteref"
    }
  }, [_vm._v("44")])]), _vm._v(" not just present in modern times (in the problem of the relation between reason and madness, illness and health, crime and law, etc.), but also within early Christianity and in Greco-Roman antiquity."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en45",
      "id": "en45r",
      "role": "doc-noteref"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', [_vm._v("But how precisely is this historico-philosophical analysis to be conducted? Foucault proposes a political approach to this question as a starting point in opposition to what he describes as an “investigation into the legitimacy of historical modes of knowing” that asks the question of the Aufklärung in terms of knowledge. He begins with the problem of power, advancing by using a “test by eventalization.” On the one hand, it is a matter of avoiding the general question of truth and legitimacy as much as possible by substituting the terms “knowledge” ("), _c('i', [_vm._v("savoir")]), _vm._v(") and “power” ("), _c('i', [_vm._v("pouvoir")]), _vm._v(") for “fields of knowledge” ("), _c('i', [_vm._v("connaissance")]), _vm._v(") and “domination” (with all their fixed limits)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en46",
      "id": "en46r",
      "role": "doc-noteref"
    }
  }, [_vm._v("46")])]), _vm._v(" The focus needs to be on “nexuses of knowledge-power” that are always specific and determined. Indeed, it is only by "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page 9. ",
      "epub:type": "pagebreak",
      "id": "p9",
      "role": "doc-pagebreak"
    }
  }), _vm._v("analyzing these nexuses, where the elements of power and the elements of knowledge are never dissociated, that it becomes possible to effect the passage from the empirical observability of a group of elements (the systems of mental illness, penality, delinquency, sexuality, etc.) to its historical acceptance. This is what Foucault describes as the archaeological level."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en47",
      "id": "en47r",
      "role": "doc-noteref"
    }
  }, [_vm._v("47")])]), _vm._v(" On the other hand, it needs to be demonstrated that these groups are not self-evident or necessary and are not enrolled in any transcendental a priori. This means analyzing these groups as “pure singularities,” which must be seen as so many "), _c('i', [_vm._v("effects")]), _vm._v(", without reducing them to “a unitary primary cause.” Here we are at the genealogical level, which tries to restore “the conditions of the appearance of a singularity from multiple determining elements.” It does this without ever operating a principle of closure, as the relations which make it possible to account for a singular effect display varying margins of uncertainty and a perpetual mobility. This is why this analysis is "), _c('i', [_vm._v("strategic")]), _vm._v(" in addition to being archaeological and genealogical."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en48",
      "id": "en48r",
      "role": "doc-noteref"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', [_vm._v("Approaching the question of the Aufklärung in this way (namely, in terms of the problem of the relationships between power, truth, and subject) means that power is not made to work as a fundamental datum or single principle of explanation. Instead, power is always considered “as a relation in a field of interactions” and associated “with a field of possibility and as such the subject of reversibility and possible reversal.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en49",
      "id": "en49r",
      "role": "doc-noteref"
    }
  }, [_vm._v("49")])]), _vm._v(" For Foucault, in other words, revisiting the question of the Aufklärung does not mean trying to understand how knowledge can form the right idea of itself, but rather highlighting the ethico-political value of an individual and collective "), _c('i', [_vm._v("attitude")]), _vm._v(" that consists in no longer wanting to be governed in a particular way. In 1978 (and in 1983–84) the analysis of Kant’s "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page 10. ",
      "epub:type": "pagebreak",
      "id": "p10",
      "role": "doc-pagebreak"
    }
  }), _vm._v("text on the Enlightenment was therefore a way for Foucault to take stock of his own intellectual journey and assess the unique character of his work and its positioning in the field of contemporary philosophy.")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ahintro03"
    }
  }, [_vm._v("The Aufklärung and the Historical Ontology of Ourselves")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The question of critique and the Aufklärung appeared in several talks and texts in the following years without ever being the central focus. It then reemerged in a significant way in 1983, with Foucault deciding to devote the first lecture of his Collège de France course "), _c('i', [_vm._v("The Government of Self and Others")]), _vm._v(" to the discussion of “Was ist Aufklärung?” and, more concisely, of the second dissertation in "), _c('i', [_vm._v("The Contest of the Faculties")]), _vm._v(" (1798), where Kant asks the question, “What is the [French] Revolution?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en50",
      "id": "en50r",
      "role": "doc-noteref"
    }
  }, [_vm._v("50")])]), _vm._v(" According to Foucault, these two texts testify to a specific way of philosophizing involving the interrogation of contemporary reality, an approach he argues was more or less inaugurated by Kant. Foucault does not emphasize this theme in his presentation to the Société française de Philosophie, but it is the most consistent element in his later series of texts and talks addressing Kant’s article on the Enlightenment."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en51",
      "id": "en51r",
      "role": "doc-noteref"
    }
  }, [_vm._v("51")])]), _vm._v(" This is also the case in Foucault’s lecture at the University of California, Berkeley, on April 12, 1983. Here, to explain why he is so interested in the theme of “the culture of the self,” he begins by commenting on “Was ist Aufklärung?” emphasing that it was a “philosophical interrogation of the present,” formulated in terms of a “very specific achievement” in the “general history of the way we use our reason.” Foucault claims that Kant’s text introduced “a new kind of question” into philosophy: it is not the question "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page 11. ",
      "epub:type": "pagebreak",
      "id": "p11",
      "role": "doc-pagebreak"
    }
  }), _vm._v("of how not to be governed in a particular way but of the historico-philosophical significance “of the precise moment when the philosopher is writing and of which he himself is a part.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en52",
      "id": "en52r",
      "role": "doc-noteref"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', [_vm._v("So in 1983, Foucault does not explicitly identify the question of Aufklärung with the critical attitude but with a different “historico-critical” question: What are we now? If he still locates a certain gap between “Was ist Aufklärung?” and the Kantian critical enterprise proper, he describes this gap in a new way. In this version, Kant inaugurated two irreducible philosophical traditions, even if these are linked in his own works. On the one hand, there is the tradition of the “formal ontology of truth” or the “critical analysis of knowledge” (What is truth? How is it possible to know the truth?). On the other, there is the tradition of “the historical ontology of ourselves” or “the critical history of thought” (What is our present reality? What are we as part of this present reality?)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en53",
      "id": "en53r",
      "role": "doc-noteref"
    }
  }, [_vm._v("53")])]), _vm._v(" Here, Foucault revisits the structure he had proposed a few months earlier at the Collège de France. This structure linked Kant’s critical work to the tradition of “the analytic of truth,” and his texts on the Aufklärung and the Revolution to a contrary critical tradition that raised the question of the “present field of possible experiences.” Foucault called this “an ontology of the present, of present reality, an ontology of modernity, an ontology of ourselves.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en54",
      "id": "en54r",
      "role": "doc-noteref"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', [_vm._v("By asserting at Berkeley that he belongs to the second tradition, Foucault claims that “any ontological history of ourselves must analyze three sets of relations: our relations to truth, our relations to obligation, our relations to ourselves and others.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en55",
      "id": "en55r",
      "role": "doc-noteref"
    }
  }, [_vm._v("55")])]), _vm._v(" We recognize here the “source of critique” as Foucault defined it in 1978—namely, the relationships woven between subject, power, and truth."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en56",
      "id": "en56r",
      "role": "doc-noteref"
    }
  }, [_vm._v("56")])]), _vm._v(" In 1983, Foucault goes "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page 12. ",
      "epub:type": "pagebreak",
      "id": "p12",
      "role": "doc-pagebreak"
    }
  }), _vm._v("on to specify that while he had been led to primarily accentuate our relation to truth and power when he was studying madness, psychiatry, crime, and punishment, he now wants to study “the constitution of our experience of sexuality.” He notes he is increasingly interested in our relationship with ourselves and “techniques of the self.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en57",
      "id": "en57r",
      "role": "doc-noteref"
    }
  }, [_vm._v("57")])]), _vm._v(" In volume 1 of "), _c('i', [_vm._v("The History of Sexuality")]), _vm._v(", Foucault approached the sexual subject from the angle of its subjugation to a "), _c('i', [_vm._v("scientia sexualis")]), _vm._v(" and to the relations of power with which it was associated."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en58",
      "id": "en58r",
      "role": "doc-noteref"
    }
  }, [_vm._v("58")])]), _vm._v(" But it was in studying the experience of sexuality in Greco-Roman antiquity that he became aware of the crucial role played by the techniques of the self. These allowed one to form oneself autonomously (or at least partially) with respect to science and relations of power. Thus, in “The Culture of the Self,” Foucault uses the discussion of Kant’s text on the Enlightenment and of the historical ontology of ourselves to define the philosophical framework he claims to have always worked within."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en59",
      "id": "en59r",
      "role": "doc-noteref"
    }
  }, [_vm._v("59")])]), _vm._v(" This framework analyzes the relation to oneself and the techniques of the self that preside over the constitution of ourselves, and are also at the center of the “Greco-Latin culture of the self.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en60",
      "id": "en60r",
      "role": "doc-noteref"
    }
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', [_vm._v("The close link Foucault establishes between the study of “Was ist Aufklärung?” and his analyses of Greco-Roman antiquity is a distinctive feature of the Berkeley lecture when compared with his other texts and talks of the same period, where Foucault’s discussion of “Was ist Aufklärung?” remained quite disconnected from his analyses of antiquity. This is with the exception of a lecture at the University of Vermont in October 1982, where Foucault maintained that the question formulated by Kant in his text on the Enlightenment (What are we now?) defines “the general framework” of the study of technologies "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page 13. ",
      "epub:type": "pagebreak",
      "id": "p13",
      "role": "doc-pagebreak"
    }
  }), _vm._v("of the self."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en61",
      "id": "en61r",
      "role": "doc-noteref"
    }
  }, [_vm._v("61")])]), _vm._v(" The “excursus” or “little epigraph” in the first lecture of "), _c('i', [_vm._v("The Government of Self and Others")]), _vm._v(" course,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en62",
      "id": "en62r",
      "role": "doc-noteref"
    }
  }, [_vm._v("62")])]), _vm._v(" marks a theme endowed with a perfect autonomy in the article published in 1984 in the United States."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en63",
      "id": "en63r",
      "role": "doc-noteref"
    }
  }, [_vm._v("63")])]), _vm._v(" It is only in “The Culture of the Self” that the reflection on Kant and the Aufklärung is tied in an explicit and structured way to the work that Foucault was undertaking on the texts of the ancient philosophers.")]), _vm._v(" "), _c('p', [_vm._v("In wondering about the massive “return” of Kant’s text in Foucault’s talks in 1983, one is forced to recognize the close relationship between the critical attitude and the “courage of the Aufklärung,” as Foucault defined these notions in 1978, and his study of ancient "), _c('i', [_vm._v("parrēsia")]), _vm._v(" as the courage of truth. Foucault was perfectly aware of this. Thus, in the last lecture of "), _c('i', [_vm._v("The Government of Self and Others")]), _vm._v(", he argues that “Was ist Aufklärung?” is a way for philosophy to account for problems “which were traditionally problems of "), _c('i', [_vm._v("parrēsia")]), _vm._v(" in antiquity.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en64",
      "id": "en64r",
      "role": "doc-noteref"
    }
  }, [_vm._v("64")])]), _vm._v(" In the series of lectures he gave at the University of California, Berkeley, in the fall of 1983, he states that “by analyzing this notion of "), _c('i', [_vm._v("parrēsia")]), _vm._v("” he wanted “to outline the genealogy of what we could call the critical attitude in our society.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en65",
      "id": "en65r",
      "role": "doc-noteref"
    }
  }, [_vm._v("65")])]), _vm._v(" It is probable that the “discovery” of "), _c('i', [_vm._v("parrēsia")]), _vm._v(" contributed to the increasing reflections on Kant and Aufklärung in Foucault’s texts and lectures in 1983–84. But this link was not the only one, as “The Culture of the Self” demonstrates. Moreover, it is quite remarkable that, during the debate with the Department of French at the University of California, Berkeley, that took place shortly after this lecture, Foucault maintained that the same pastoral counterconducts he had presented in 1978 as the antecedents of the critical attitude also constituted a “reappearance of more autonomous forms” of the culture of the self in the Middle Ages."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en66",
      "id": "en66r",
      "role": "doc-noteref"
    }
  }, [_vm._v("66")])])])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ahintro04"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page 14. ",
      "epub:type": "pagebreak",
      "id": "p14",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Cultures of the Self")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The organization of the Berkeley lecture proves to be very close to Foucault’s analyses published in "), _c('i', [_vm._v("The Hermeneutics of the Subject")]), _vm._v(", particularly in his long summary of this course."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en67",
      "id": "en67r",
      "role": "doc-noteref"
    }
  }, [_vm._v("67")])]), _vm._v(" On the other hand, its structure is quite different from the second chapter of "), _c('i', [_vm._v("The Care of the Self")]), _vm._v(", which bears the same title."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en68",
      "id": "en68r",
      "role": "doc-noteref"
    }
  }, [_vm._v("68")])]), _vm._v(" After the opening discussion on Kant’s text on the Enlightenment, “The Culture of the Self” advances in three stages.")]), _vm._v(" "), _c('p', [_vm._v("First, Foucault emphasizes the great historical importance of the principle of "), _c('i', [_vm._v("epimeleia heautou")]), _vm._v(" from Socrates to Gregory of Nyssa, explaining that in antiquity the rule and practice of knowing yourself were constantly associated and subordinated to the care of the self. This is why Foucault studies the "), _c('i', [_vm._v("epimeleia heautou")]), _vm._v(" in Greco-Roman culture as a “practical matrix for the experience of the self.” Indeed, if “Greek metaphysics has determined our philosophical relationship to being,” and if “Greek science has determined our rational relationship to the world,” Greco-Roman culture has determined, according to Foucault, “our ethical relation to ourselves.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en69",
      "id": "en69r",
      "role": "doc-noteref"
    }
  }, [_vm._v("69")])]), _vm._v(" Foucault then proposes a close comparison between the form taken by this culture of the self in the fourth century BC and the first two centuries AD. Thus, in the Berkeley lecture, the expression “the culture of the self” does not just apply to the imperial period—where “the principle of care of oneself became rather general in scope,” constituting a social practice and giving rise to the development of a genuine form of knowledge"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en70",
      "id": "en70r",
      "role": "doc-noteref"
    }
  }, [_vm._v("70")])]), _vm._v("—but also to classical Greece: “The culture of the self was not a late phenomenon in the wake of the decline of the classical city; it was an early phenomenon taking several forms in antiquity.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en71",
      "id": "en71r",
      "role": "doc-noteref"
    }
  }, [_vm._v("71")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page 15. ",
      "epub:type": "pagebreak",
      "id": "p15",
      "role": "doc-pagebreak"
    }
  }), _vm._v("In the second stage of his argument, Foucault analyzes Plato’s "), _c('i', [_vm._v("Alcibiades")]), _vm._v(" as the first philosophical elaboration of the principle of "), _c('i', [_vm._v("epimeleia heautou")]), _vm._v(". Summarizing the analyses in his course "), _c('i', [_vm._v("The Hermeneutics of the Subject")]), _vm._v(","), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en72",
      "id": "en72r",
      "role": "doc-noteref"
    }
  }, [_vm._v("72")])]), _vm._v(" Foucault emphasizes four points which, in his view, characterized the culture of the self in the fourth century. (1) The care of the self was linked to the political ambition of a young man who must first learn to care for himself in order to be able to govern the city. (2) The care of the self was linked to insufficient or defective pedagogy, one unable to teach the young man what he needed to carry out his project. (3) It was linked to an erotic and philosophical relationship between the young man and the teacher. And (4), the care of the self in the "), _c('i', [_vm._v("Alcibiades")]), _vm._v(" “takes the principal form of the soul’s self-contemplation.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en73",
      "id": "en73r",
      "role": "doc-noteref"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', [_vm._v("In the third stage of his argument, Foucault describes the main features of the “new culture of the self” in the imperial era on the basis of this simple outline."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en74",
      "id": "en74r",
      "role": "doc-noteref"
    }
  }, [_vm._v("74")])]), _vm._v(" First, the relationship with oneself became permanent: taking care of oneself was no longer “a simple and momentary preparation for life; it [was] a form of life.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en75",
      "id": "en75r",
      "role": "doc-noteref"
    }
  }, [_vm._v("75")])]), _vm._v(" Second, the relation to oneself, which had become an adult practice, acquired new functions. These functions were as follows: a critical function (because you needed to get rid of bad habits, false opinions, and so on); a function of struggle (because the individual must be given “the weapons and courage that will enable him to fight his entire life”); a therapeutic function (philosophy being called on to cure diseases of the soul)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en76",
      "id": "en76r",
      "role": "doc-noteref"
    }
  }, [_vm._v("76")])]), _vm._v(" Third, the relationship with the master lost its erotic character and became a relationship of authority, a technical, administrative, and institutional relationship. Finally, fourth, the “new” culture of the self involved a widely varied set of techniques of the self, very different from pure contemplation of the soul."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en77",
      "id": "en77r",
      "role": "doc-noteref"
    }
  }, [_vm._v("77")])]), _vm._v(" (Foucault focuses in particular "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page 16. ",
      "epub:type": "pagebreak",
      "id": "p16",
      "role": "doc-pagebreak"
    }
  }), _vm._v("on writing practices as techniques of the self at Berkeley.) Thus, if it is indeed possible to speak of a “culture of the self” in the fourth century BC, it was only during the imperial period that this culture was realized to its full extent."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en78",
      "id": "en78r",
      "role": "doc-noteref"
    }
  }, [_vm._v("78")])])]), _vm._v(" "), _c('p', [_vm._v("How is it, then, that the theme of the care of the self seems to have “disappeared” in the modern and contemporary world? Foucault provides several reasons for this. One reason is the influence of Christianity, which formulated the care of the self in terms of self-renunciation. Another reason is the integration of techniques of the self into structures of authority and discipline, in such a way that the culture of the self lost its autonomy. Further, there is the emergence of the human sciences, which conceive of the relation to the self as a relation of knowledge. And finally, there is the idea that the self is a hidden reality that needs to be revealed or liberated."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en79",
      "id": "en79r",
      "role": "doc-noteref"
    }
  }, [_vm._v("79")])]), _vm._v(" But, as Foucault explains in the debate with the Department of Philosophy, “the self is not a reality that is a given at the beginning which must develop in accordance with a certain pattern or model.” Instead, the self "), _c('i', [_vm._v("is constituted")]), _vm._v(" “through a number of practices, techniques which are characteristic of ethics.” The self is not a substance, but a set of relationships it establishes with itself."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en80",
      "id": "en80r",
      "role": "doc-noteref"
    }
  }, [_vm._v("80")])]), _vm._v(" So, as he had done in his lectures "), _c('i', [_vm._v("About the Beginning of the Hermeneutics of the Self")]), _vm._v(", where he had spoken of a “politics of ourselves,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en81",
      "id": "en81r",
      "role": "doc-noteref"
    }
  }, [_vm._v("81")])]), _vm._v(" Foucault concludes his lecture “The Culture of the Self” by affirming that the self is nothing other than “the correlative of technologies built and developed throughout our history.” The problem is not to free the self but to consider “how it could be possible to elaborate new types and new kinds of relationships to ourselves.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en82",
      "id": "en82r",
      "role": "doc-noteref"
    }
  }, [_vm._v("82")])]), _vm._v(" In other words, for Foucault, restoring a historical and practical dimension to the self does not mean, “bringing the whole weight of our "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page 17. ",
      "epub:type": "pagebreak",
      "id": "p17",
      "role": "doc-pagebreak"
    }
  }), _vm._v("history down on our shoulders. Rather, it is to make available for the work that we can do on ourselves the largest possible share of what is presented to us as inaccessible.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en83",
      "id": "en83r",
      "role": "doc-noteref"
    }
  }, [_vm._v("83")])]), _vm._v(" This is one of the reasons why the space of reflexivity brought to light by the idea of “conducting "), _c('i', [_vm._v("oneself")]), _vm._v("” turns out to be crucial to the way Foucault conceives the work of ethics."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en84",
      "id": "en84r",
      "role": "doc-noteref"
    }
  }, [_vm._v("84")])])]), _vm._v(" "), _c('p', [_vm._v("This historico-philosophical and ethico-political endeavor is explicitly linked to what Foucault called “the historical ontology of ourselves,” drawing from “Was ist Aufklärung?” In this context, the question, Who are we? is not in fact a Cartesian question which is premised on “a unique but universal and unhistorical subject”—“Who am "), _c('i', [_vm._v("I?")]), _vm._v(" [. . .] "), _c('i', [_vm._v("I")]), _vm._v(", for Descartes is everyone, anywhere, at any moment.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en85",
      "id": "en85r",
      "role": "doc-noteref"
    }
  }, [_vm._v("85")])]), _vm._v(" Instead, the question Kant is asking in his text on the Enlightenment is a Nietzschean question avant la lettre."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en86",
      "id": "en86r",
      "role": "doc-noteref"
    }
  }, [_vm._v("86")])]), _vm._v(" We are asking who we are "), _c('i', [_vm._v("today")]), _vm._v(", “at this precise moment in which we are living,” thus taking into account the contingent dimension of our form of the “self,” and opening up the (theoretical and practical) possibility of “refus[ing] what we are.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en87",
      "id": "en87r",
      "role": "doc-noteref"
    }
  }, [_vm._v("87")])]), _vm._v(" It is about inventing new forms of the relationship to ourselves. Foucault concludes his article, published in 1984 in the United States, in a similar way: “The critical ontology of ourselves,” he claims, “must be considered [. . .] as an attitude, an ethos, a philosophical life in which the critique of what we are is at one and the same time the historical analysis of the limits imposed on us and an experiment with the possibility of going beyond them ["), _c('i', [_vm._v("de leur franchissement possible")]), _vm._v("].”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en88",
      "id": "en88r",
      "role": "doc-noteref"
    }
  }, [_vm._v("88")])]), _vm._v(" For all his interest in the Greco-Roman culture of the self as an aesthetic of existence, Foucault is not, in fact, proposing a return to ancient ethics as an “alternative” to contemporary moral models. Instead, he believes that this culture is in a position to show us the possibility of building a "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page 18. ",
      "epub:type": "pagebreak",
      "id": "p18",
      "role": "doc-pagebreak"
    }
  }), _vm._v("“new ethics,” which, in the wake of the work of historical analysis tied to “the ethical imagination,” bypasses the three major, and now weakened, references of religion, law, and science."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "epub:type": "noteref",
      "href": "#/chifoucaultcritique0013#en89",
      "id": "en89r",
      "role": "doc-noteref"
    }
  }, [_vm._v("89")])])]), _vm._v(" "), _c('p', {
    staticClass: "patr"
  }, [_vm._v("Daniele Lorenzini and Arnold I. Davidson")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e4f6040","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-foucault-critique-0010.vue
// module id = 81
// module chunks = 0